// eslint-disable-next-line
// new 2020-06
// https://cli.vuejs.org/guide/browser-compatibility.html#polyfills
// https://github.com/zloirock/core-js/blob/master/docs/2019-03-19-core-js-3-babel-and-a-look-into-the-future.md
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer'; // polyfill for lozad
// babel/polyfill is deprecated
// https://babeljs.io/docs/en/babel-polyfill
// https://cli.vuejs.org/guide/browser-compatibility.html#usebuiltins-

import Vue from 'vue';
import cookies from 'js-cookie';

import axios from 'axios';
import VueAxios from 'vue-axios';
import VueMeta from 'vue-meta';

import 'bootstrap';
import _ from 'lodash';
import uuid from 'uuid/v4';

import VueLazyload from 'vue-lazyload';
import VueGtm from '@gtm-support/vue2-gtm';
import Rollbar from 'vue-rollbar';



// https://www.npmjs.com/package/v-mask
import VueMask from 'v-mask';
import Vuelidate from 'vuelidate';
import VueScrollTo from 'vue-scrollto';
import fileSize from 'filesize';

import VueClipboard from 'vue-clipboard2';
import InfiniteLoading from 'vue-infinite-loading';

// me-modules
import meHelper from '@motionelements/helper';
import * as teleport from '@motionelements/teleport';

// by steve/marksun for product 2020-06
import player from '@motionelements/helper/player/index.js';

import {
  TablePlugin,
  DropdownPlugin,
  TooltipPlugin,
  CollapsePlugin,
  SidebarPlugin,
  ModalPlugin,
} from 'bootstrap-vue';
import VTooltip from 'v-tooltip';

import link from '@motionelements/core/src/helpers/link.js';
// init services store
import { setStore as setAccountServiceStore } from '@motionelements/core/src/services/account.service.js';
import { setStore as setAppServiceStore } from '@motionelements/core/src/services/app.service.js';
import { EventBus } from '@motionelements/core/src/services/event-bus.service.js';
import { setStore as setNotificationServiceStore } from '@motionelements/core/src/services/notification.service.js';
import { setStore as setLanguageStore } from '@motionelements/core/src/services/language.service.js';
import { setStore as setApiStore } from '@motionelements/core/src/api/base-api-v2';

import iconBase from '@motionelements/assets/src/js/me-font/icons-base.js';

import schema from '@motionelements/helper/schema.js';
import * as tools from '@/tools/index.js';


// dyanmicI18nFeatureEnabled
// not reducing filesize yet
// import { i18n, loadLanguageAsync } from '@/setup/i18n-setup.js';

// import * as meTeleport from '@motionelements/core/src/services/teleport.service.js';

import App from './App.vue';
import router from './router/index.js';
import store from './store';

// import iconFont from '@motionelements/assets/src/js/me-font/icons-product.js';
import iconFont from './assets/js/me-font/icons-search.js';

import i18n from './lang/i18n.js';

// import after store

// vue layout define
// existing wico's search layout

// import defaultLayout from './layouts/DefaultLayout.vue';
// import defaultLayout from './layouts/SearchLayout.vue';
// //
// Vue.component('default-layout', defaultLayout);
// Vue.component('search-layout', searchLayout);

const isProduction = process.env.VUE_APP_ENV === 'production';
const isPrerender = process.env.VUE_APP_PRERENDER === 'true' || (navigator.userAgent || '').indexOf('HeadlessChrome') !== -1;

Vue.config.productionTip = true;
Vue.config.devtools = !isProduction;
Vue.config.performance = !isProduction;

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 2,
});

Vue.use(iconBase);
Vue.use(iconFont);
Vue.use(VueMeta, {
  keyName: 'head', // compatible with Nuxt
  tagIDKeyName: 'hid', // compatible with Nuxt
});
// https://www.npmjs.com/package/v-mask
Vue.use(VueMask);
Vue.use(Vuelidate);
Vue.use(VueScrollTo, { duration: 800 });
Vue.use(InfiniteLoading);

Vue.use(TablePlugin);
Vue.use(DropdownPlugin);
Vue.use(TooltipPlugin);
Vue.use(CollapsePlugin);
Vue.use(SidebarPlugin);
Vue.use(ModalPlugin);
Vue.use(VTooltip, {
  defaultTrigger: 'click hover',
});

// VueClipBoard need this setting in modal
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Object.defineProperty(Vue.prototype, '$locale', {
  get() {
    return i18n.locale;
  },
  set(locale) {
    i18n.locale = locale;
  },
});

setAccountServiceStore(store);
setAppServiceStore(store);
setNotificationServiceStore(store);
setApiStore(store);
setLanguageStore(store);



Vue.use(VueGtm, {
  // container id
  id: process.env.VUE_APP_GTM_ID,
  // queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
  //   gtm_auth: process.env.VUE_APP_GTM_AUTH,
  //   gtm_preview: process.env.VUE_APP_GTM_PREVIEW,
  //   gtm_cookies_win: 'x',
  // },
  vueRouter: router,
  // enable track or not (optional)
  // enabled: !isPrerender && ['production', 'staging', 'development'].includes(process.env.VUE_APP_ENV),
  enabled: !isPrerender && !['testing'].includes(process.env.VUE_APP_ENV),
  // display console logs debugs or not (optional)
  // debug: (['production', 'stage'].indexOf(process.env.NODE_ENV) < 0),
  debug: !isProduction,
});

Vue.use(Rollbar, {
  accessToken: process.env.VUE_APP_ROLLBAR_TOKEN,
  hostSafeList: ['motionelements.com', 'cloudfront.net'],
  captureUncaught: !isProduction,
  captureUnhandledRejections: !isProduction,
  verbose: !isProduction,
  enabled: !isPrerender && ['production', 'staging'].includes(process.env.VUE_APP_ENV),
  environment: process.env.VUE_APP_ENV,
  // payload: {
  //   client: {
  //     javascript: {
  //       code_version: '1.0',
  //     },
  //   },
  // },
});

// eslint-disable-next-line
// const unsync = sync(store, router);

// Vue.prototype.$VueBus = new Vue();

Vue.prototype._ = _;
// eslint-disable-next-line no-underscore-dangle
Vue.prototype.$_ = _; // use $_ for Nuxt compatiblity
Vue.prototype.$uuid = uuid;
Vue.prototype.$axios = axios;
Vue.prototype.$cookies = cookies;

Vue.prototype.$audioPlayer = player.audioPlayer;
Vue.prototype.$videoPlayer = player.videoPlayer;
Vue.prototype.$videoPlayerSettings = player.videoPlayerSettings; // split normal video player and need change settings, ex: gif-creator
Vue.prototype.$bus = EventBus;

Vue.prototype.$scrollToTop = () => window.scrollTo({ top: 0 });
Vue.prototype.$scrollTo = (selector) => { document.querySelector(selector).scrollIntoView({ behavior: 'smooth' }); };

Vue.prototype.$schema = schema;
Vue.prototype.$siteUrl = meHelper.siteUrl;
Vue.prototype.$term = meHelper.term;
Vue.prototype.$site = meHelper.site;
Vue.prototype.$wbr = meHelper.wbr;

Vue.prototype.$link = link;

Vue.prototype.$teleport = teleport;

Vue.prototype.$tools = tools;
Vue.prototype.$fileSize = fileSize;
Vue.prototype.$hasOwnProp = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);


Vue.config.errorHandler = function (err, vm) {
  if (!isProduction) {
    vm.$rollbar.error(err);
    throw err;
  }
};

Vue.use(VueAxios, axios);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
